import { IJsonQuery } from './types';
import { setGeo } from './helpers';

export function clearGeo(jsonQuery: IJsonQuery): () => IJsonQuery {
  return () => setGeo()(jsonQuery)([]);
}
